import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagCambioCuenta12FormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagCambioCuenta12'>
      {({ field }) => (
        <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagCambioCuenta12' label='Cambio Cuenta Contable 12' />
      )}
    </Field>
  )
}

export default React.memo(FlagCambioCuenta12FormGroup)
